<template>
  <div class="pompe-tabs">
    <ul class="nav nav-tabs mt-3 mb-3">
      <li
        v-for="(item, idx) in items"
        :key="idx"
        :id="item.page"
        class="nav-item"
      >
        <a
          class="nav-link"
          :class="item.page === selectedTab ? 'active' : ''"
          href="javascript:void(0)"
          @click.prevent="$emit('action:select-tab', item.page)"
        >
          {{ item.label }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Tabs",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    selectedTab: {
      type: [String, Number],
      default: null,
    },
  },
};
</script>

<style></style>
